import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import { FormControl } from "@mui/material";
import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Controller } from "react-hook-form";
import ReactSelect, { components } from "react-select";

const MenuPortal = ({ children, isOpen }) => {
  if (!isOpen) return null;
  return createPortal(
    <div
      style={{
        position: "fixed",
        zIndex: 9999,
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        fontSize: "11px",
        pointerEvents: "auto",
      }}
    >
      {children}
    </div>,
    document.body
  );
};

const TableDropDownField = ({
  className,
  isDisabled,
  placeholdernotVisible,
  isMulti,
  inputRef,
  control,
  error,
  dataArray,
  name,
  placeholder,
  isClearable,
  defaultValue,
  searchIcon,
  isSearchable,
  menuPlacement,
  menuShouldBlockScroll,
  referance,
  onChange,
  onKeyDown,
}) => {
  const ref = useRef(null);
  const [menuPosition, setMenuPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (isClearable == true) {
      let inPx = `${ref.current.offsetWidth - 200}px`;
      setWidth(inPx);
    } else {
      let inPx = `${ref.current.offsetWidth - 200}px`;
      setWidth(inPx);
    }
  }, []);

  useLayoutEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isOpen]);

  if (menuPlacement) {
  } else {
    menuPlacement = "auto";
  }
  if (menuShouldBlockScroll !== true) {
    menuShouldBlockScroll = false;
  }

  if (isSearchable !== true) {
    isSearchable = false;
  }
  let isError = !!error?.message;

  const selectStyles = {
    menu: (styles) => ({
      ...styles,
      position: "absolute",
      boxShadow: "0 20px 54px 0 rgba(0,0,0,0.2)",
      zIndex: 50,
      fontStyle: "normal",
      fontSize: "11px",
      lineHeight: "16px",
      minWidth: ref.current.offsetWidth,
      width: "fit-content",
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: "200px",
    }),
    option: (provided, { isDisabled, isFocused, isSelected }) => ({
      ...provided,
      whiteSpace: "nowrap",
      zIndex: "1000",
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? "rgba(222,235,255,1)"
        : isFocused
        ? "rgba(222,235,255,0.5)"
        : undefined,

      color: isDisabled
        ? undefined
        : isSelected
        ? "#000000"
        : isFocused
        ? "#000000"
        : undefined,
    }),
    control: (Colstyles, state) => ({
      ...Colstyles,
      borderRadius: "5px",
      minHeight: "20px",
      maxHeight: "25px",
      borderColor: "#0B83A5",
      textOverflow: "ellipsis",
      display: "flex",
      flexWrap: isMulti ? "wrap" : "nowrap",
      border: isError
        ? state.isSelected
          ? "1px solid #0B83A5"
          : state.isFocused
          ? "1px solid #0B83A5"
          : state.hasValue || state.selectProps.inputValue
          ? "1px solid #d32f2f"
          : "1px solid #d32f2f"
        : state.hasValue || state.selectProps.inputValue
        ? ""
        : "",
    }),
    singleValue: (Singstyles) => ({ ...Singstyles, padding: "0px" }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: "none",
      padding: "0px",
    }),
    clearIndicator: (styles) => ({ ...styles, padding: "0px !important" }),

    valueContainer: (provided, state) => ({
      ...provided,
      position: "relative",
      width: width,
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "visible",
      borderColor: "#0B83A5",
      display: "flex",
      flexWrap: isMulti ? "wrap" : "nowrap",
      maxHeight: "fit-content",
      fontSize: "11px",
      textOverflow: "clipped",
      overFlowX: "hidden",
      paddingLeft: state.hasValue || state.selectProps.inputValue ? 3 : 3,
      fontStyle: "normal",
    }),
    input: (provided, state) => ({
      ...provided,
      fontSize: "11px",
      overflow: "clip",
    }),
    placeholder: (provided, state) => ({
      ...provided,

      color: isSearchable
        ? ""
        : state.menuIsOpen || state.selectProps.menuIsOpen
        ? isDisabled
          ? "#eaeaea"
          : "#1976D2"
        : isError
        ? "#d32f2f"
        : "#9e9e9e",

      fontSize: isSearchable
        ? ""
        : (state.menuIsOpen ||
            state.selectProps.menuIsOpen ||
            state.hasValue ||
            state.selectProps.inputValue) &&
          12,
      transition: "top 0.1s, font-size 0.1s",

      marginTop: "0px",

      zIndex:
        state.menuIsOpen ||
        state.selectProps.menuIsOpen ||
        state.hasValue ||
        state.selectProps.inputValue
          ? 10
          : "",

      fontStyle: "normal",
    }),
  };

  const Menu = (props) => {
    return (
      <MenuPortal isOpen={isOpen}>
        <div
          style={{
            position: "absolute",
            top: `${menuPosition.top}px`,
            left: `${menuPosition.left}px`,
            width: `${menuPosition.width}px`,
            pointerEvents: "auto",
          }}
        >
          <components.Menu {...props} />
        </div>
      </MenuPortal>
    );
  };

  return (
    <div className="w-full " ref={ref} style={{ position: "relative" }}>
      <FormControl fullWidth sx={{ overFlowX: "hidden" }}>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field: { onChange: fieldOnChange, ...field } }) => (
            <ReactSelect
              className={className}
              isDisabled={isDisabled}
              inputRef={inputRef}
              {...field}
              ref={referance}
              isMulti={isMulti}
              closeMenuOnSelect={isMulti ? false : true}
              options={dataArray}
              onKeyDown={onKeyDown}
              isClearable={isClearable}
              clearValue={true}
              isSearchable={isSearchable}
              placeholder={placeholder}
              defaultValue={defaultValue}
              styles={selectStyles}
              blurInputOnSelect={true}
              menuPlacement={menuPlacement}
              menuShouldBlockScroll={menuShouldBlockScroll}
              onMenuOpen={() => setIsOpen(true)}
              onMenuClose={() => setIsOpen(false)}
              onChange={(selectedOption) => {
                fieldOnChange(selectedOption);
                if (onChange) {
                  if (selectedOption) {
                    onChange(selectedOption.value || selectedOption.label);
                  } else {
                    onChange(null);
                  }
                }
              }}
              onInputChange={(inputValue, actionMeta) => {
                if (actionMeta.action === "input-change" && onChange) {
                  onChange(inputValue);
                }
              }}
              components={{
                Menu,
                DropdownIndicator: () =>
                  isMulti ? (
                    <KeyboardArrowDownIcon className=" text-gray-600" />
                  ) : searchIcon ? (
                    <SearchIcon fontSize="small" className=" text-gray-600" />
                  ) : (
                    <KeyboardArrowDownIcon className=" text-gray-600" />
                  ),
              }}
            />
          )}
        />
      </FormControl>
    </div>
  );
};

export default TableDropDownField;
